import React, { Component } from 'react';
import { Field, reduxForm, getFormValues } from 'redux-form';
import { connect } from 'react-redux'
import InputField from '../../../../../helpers/Fields/InputField';
import SelectField from '../../../../../helpers/Fields/SelectField';
import { required, email } from 'redux-form-validators'
import PropTypes from 'prop-types'
import {toastr} from 'react-redux-toastr'
import { createQuestionCategory, updateQuestionCategory } from '../../../../actions';


class FormContent extends Component {
  static contextTypes = {formatMessage: PropTypes.any};
  constructor(props) {
    super(props)
    this.state = {
      hasPassoword: props.initialValues.password
    }
  }
  

  submit = async (values)=> {
    try {
      const {formatMessage} = this.context;
      const {handleClose} = this.props;

      if(values.id){
        await this.props.updateQuestionCategory(values);
        toastr.success(formatMessage('msgNotificationTitleQuestionCategoryCreaded'), formatMessage('msgNotificationQuestionCategoryCreated'))

      } else {
        await this.props.createQuestionCategory(values);
        toastr.success(formatMessage('msgNotificationTitleQuestionCategoryUpdated'), formatMessage('msgNotificationQuestionCategoryUpdated'))
      }
      
      handleClose();
    } catch (error) {
    }
    
  }

  render() {
    const {formatMessage} = this.context
    let { handleSubmit, handleClose, initialValues, valuesForm, categories } = this.props;
    if(!valuesForm){
      valuesForm = {};
    }
    return (
      <form className="create-dialog-form" onSubmit={handleSubmit(this.submit)}>
        <Field 
          name='name'
          label={formatMessage('txtCaptionQuestionCategory')}
          component={InputField}
          validate={[required()]}
        />

        {!initialValues.id && <Field 
          name='parent_id'
          label={formatMessage('txtCaptionQuestionSubCategory')}
          component={SelectField}
          options={[...categories.filter(_i => !_i.parent_id).map(_i => ({title: _i.name, value: _i.id}))]}
        />}
        
        <div className="create-dialog-form__group flex" style={{justifyContent: 'space-between',
            flexDirection: 'row'}}>
          <button className="btn btn-warning" type="button" onClick={() => {
            handleClose();
          }}>{formatMessage('btnModalCancelQuestionCategory')}</button>
           <button className="btn btn-primary" type="submit">{formatMessage(!initialValues.id ? 'btnModalCreateQuestionCategory': 'btnModalUpdateQuestionCategory')}</button>
        </div>
         
      </form>
    );
  }
}

FormContent = reduxForm({
  form: 'form_subject',
  enableReinitialize: true,
})(FormContent);



const mapStateToProps = (state, ownProps) => ({
  valuesForm: getFormValues('form_subject')(state),
  categories: state.question.categories
})

const mapDispatchToProps = {
  createQuestionCategory,
  updateQuestionCategory,
}

export default connect(mapStateToProps, mapDispatchToProps)(FormContent);



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Question/components/Category/components/FormModal/FormContent.jsx